export const ACCESS_TYPES = [
  {value: 'all'},
  {value: 'group', qDimensionId: 'rSpKpC'},
  {value: 'account', qDimensionId: 'ywAJjj'},
  {value: 'subaccount', qDimensionId: 'XLGVRc'}
]